/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import classnames from 'classnames'

import styles from './Link.module.css'

interface ILinkProps {
  href: string
  isExternal?: boolean
  className?: string
  children: React.ReactElement | string
  onClick?(): void
}

export const Link: React.FC<ILinkProps> = ({ href, isExternal, className, children, onClick }) => (
  <a
    className={classnames(styles.link, className)}
    target={isExternal ? '_blank' : undefined}
    rel={isExternal ? 'noreferrer' : undefined}
    href={href}
    onClick={(event) => {
      event.stopPropagation()

      if (onClick) {
        onClick()
      }
    }}
  >
    {children}
  </a>
)

Link.displayName = 'Link'
